<template>
  <b-container>
    <IAMSmartProfileResultProvider
      @success="success"
      @error="error"
      :business-id="businessId"
      :errorMsg="errorMsg"
    >

    <br>
    <br>

    <b-card no-body v-if="!show && !linkIAmSmart">
      <b-card-header class="header info-header">{{ $t("getProfileTitle") }}</b-card-header>
        <h5 class="mt-4" style="text-align: center;"> {{ $t("getProfileHeader")}} </h5>
        <br>
        <p>{{ $t("getProfileInstr1")}}</p>
        <ul>
          <li>{{ $t("getProfileList1")}}</li>
          <li>{{ $t("getProfileList5")}}</li>
        </ul>
        <div class="proceed-btn">
          <div style="display: inline-block;">
            <!-- <IAMSmartButton @click="requestProfile(businessId)">{{ $t("iAmSmartInfoButton")}}</IAMSmartButton> -->
            <button class="proceed-button" @click="requestProfile(businessId)">{{ $t("iAmSmartInfoButtonPublic")}}</button>
          </div>
        </div>

    </b-card>

    <b-card no-body v-if="show">
      <b-card-header class="header">
        {{ $t("title") }}
      </b-card-header>
      <h5 class="mt-4">
        {{ $t("instrHeader") }}
      </h5>
      <br>
      <ol>
        <li class="green-text">{{ $t("instrStep1") }}</li>
        <a href="#">
          <img v-if= "!isMobile" width="10%" src="@/assets/tap.png" />
        </a>
        <li>{{ $t("instrStep2") }}</li>
        <li>{{ $t("instrStep3") }}</li>
      </ol>
      <div class="info-btn">
        <div style="display: inline-block;">
          <IAMSmartButton  v-if="show && isMobile" @click="iamsmartprofile">{{$t("iAmSmartMobileButton")}}</IAMSmartButton>
        </div>
      </div>     
    </b-card>
    <div style="text-align:center;">
      <router-link :to="{ path: '/login' }" style="text-decoration: underline;">
        {{ $t("cancelLoginButton")}}
      </router-link>
    </div>     
     <AfterLinkedIAmSmart v-if="linkIAmSmart" @useESS="assignESS" :exist="true"/>
    </IAMSmartProfileResultProvider>

  </b-container>
</template>

<script>
import LoginIAMSmartPendingView from "../../../locales/modules/login/views/LoginIAMSmartPendingView";
import {
  IAMSmartProfileResultProvider,
  IAMSmartAuthApi,
  IAMSmartButton
} from "@nextore/iam-smart";
import { IAmSmartQrCodeApi, MemberRegistrationApi } from "@/api";
import AfterLinkedIAmSmart from "../components/login/AfterLinkedIAmSmart";
import { UserService } from "@/services";

export default {
  components: {
    IAMSmartProfileResultProvider,
    IAMSmartButton,
    AfterLinkedIAmSmart
  },
  props: {
    businessId: {
      required: true
    },
    errorMsg: {},
    openIAmSmartAppUrl: {}
  },
  data() {
    return {
      show: false,
      linkIAmSmart: false,
      getIAmSmartUrl: ''
    }
  },
  computed: {
    isMobile() {
      let ua = navigator.userAgent;
      let ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
              isIphone = ua.match(/(iPhone\sOS)\s([\d_]+)/),
              isAndroid = ua.match(/(Android)\s+([\d.]+)/),
              isMobile = ipad || isIphone || isAndroid;
      return !!isMobile;
    }
  },
  beforeMount(){
    var lang = this.$route.query.lang;
    if(lang) {
      this.$root.$i18n.locale = lang;
    } 
  },
  async created() {
    const getIAmSmartUrl = await IAmSmartQrCodeApi.getIAmSmartUrl();
    this.getIAmSmartUrl = getIAmSmartUrl.data.VUE_APP_IAM_SMART_APP_URL_SCHEME;
  },
  methods: {
    async success({ businessId }) {
      this.$successToast(this.$t("loginMsgTitle"), this.$t("loginSuccessMsg"));

      const { data } = await IAMSmartAuthApi.initLoginRegistration(businessId);

      if (data.status === "Login") {
        this.linkIAmSmart = true;
        this.show = false;

        // 4894 redirect to the correct language of the login page after logining
        let lang = this.$i18n.locale.replace(/_/i, '-');
        await MemberAccountInfoSettingApi.editLanguage(lang);
        
      } else if (data.status === "Registration") {
        try{
          const { data: info } = await MemberRegistrationApi.activateIAMSmart(
          businessId
          );

          this.$router.push({
            name: "ERegistrationIAmSmartTermAndCond",
            params: {
              info : info,
              businessId : businessId
            }
          });          
        } catch(err)
        {
          console.log(err);
          this.$dangerToast(this.$t("loginMsgTitle"), this.$t("noRegRecordFound"));
          window.location.assign("/public/bd/#/login");
        }
      } else {
        this.$dangerToast("Success callback", "Undefined status");
        throw new Error("Undefined status");
      }
    },
    error( businessId,errorMsg ) {
      if(errorMsg.includes("D50001")){
        this.$dangerToast(this.$t("loginMsgTitle"), this.$t("rejectGetProfileRequest"));
      } else {
        console.log("errorMsg",errorMsg);
        this.$dangerToast(this.$t("loginMsgTitle"), errorMsg);
      }
      
      window.location.assign("/public/bd/#/login");
    },

    async iamsmartprofile() {
      document.location.href = this.openIAmSmartAppUrl;
    },

    assignESS() {
      UserService.redirectToLanding("prof");
    },

    async requestProfile(businessId){
      const reply = await IAmSmartQrCodeApi.RequestProfile(businessId);
      //  this.openIAmSmartAppUrl = `${process.env.VUE_APP_IAM_SMART_APP_URL_SCHEME}://profile?ticketID=${reply.data.getProfileRequestContent.ticketID}`;
      // this.openIAmSmartAppUrl = `${this.getIAmSmartUrl}://profile?ticketID=${reply.data.getProfileRequestContent.ticketID}`;
      // this.show=true;
      console.log("reply",reply);
      if (reply.data == true) {
        this.success({businessId});
      }
      else {
        this.error(businessId,"No registration record found");
      }
      // if(reply.data.code.includes('D0000'))
      // {
      //   var callback = {secretKey:'',content:''};
      //   const jsondata = JSON.stringify(reply.data);
      //   callback.content = jsondata;
      //   callback.secretKey = businessId;
        
      //   const { data } = await IAmSmartQrCodeApi.GetProfileRequest(callback);
      //   this.success({businessId});
      // }
      // else
      // {
      //   var errormsg = reply.data.message;
      //   this.error({businessId,errormsg});
      // }
    }
  },
  i18n: {
    messages: LoginIAMSmartPendingView
  }
};
</script>

<style>
  .green-text{
    color:#2B7366
  }

  .header{
    background-color: #2B7366;
    color: white;
    font-size: 24px;
  }

  h5, p{
    padding: 0 20px;
  }

  .info-header {
    text-align: center;
    background-color: #005d99;
    /*margin: auto;*/
  }
  .info-btn {
    text-align: center;
    margin-bottom: 30px;
  }
  .info-btn button {
    color: #fff;
    font-weight: 800;
    padding: 8px;
    border-radius: 0.25rem;
    background-color: #2B7366;
    border: none;
  }
  .proceed-btn {
    text-align: center;
    margin-bottom: 30px;
  }
  .proceed-btn button {
    color: #fff;
    font-weight: 800;
    padding: 8px;
    border-radius: 0.25rem;
    background-color: #ff8c00;
    border: none;
  }
  .proceed-button {
    background-color: #ff8c00; /* Orange color */
    color: white;              /* Text color */
    border: none;              /* No border */
    border-radius: 5px;       /* Rounded corners */
    padding: 10px 20px;       /* Padding */
    font-size: 16px;          /* Font size */
    cursor: pointer;           /* Pointer cursor on hover */
  }
</style>
